import React from 'react';
import {
  FinanceResponseData,
  FinalProduct,
} from '@upstart/harmony/lib/legos/financingTypes';
import { parseCurrencyTruncated } from '@upstart/harmony/lib/form-utils';
import { parseNumberIfPresent } from '../ricFormUtils';
import Input, { PriceInput } from '../../../../components/PencilEditor/Input';
import { FormTable } from './FormItems';

type ProductColumn = {
  title?: string;
  width: string;
  fieldName: keyof FinalProduct;
};

const REQUIRED_PRODUCT_FIELDS: (keyof FinalProduct)[] = [
  'paidTo',
  'description',
];

export function ProductTable(props: {
  columns: ProductColumn[];
  products: FinalProduct[];
  responseData: FinanceResponseData | undefined;
  onChange: (data: Partial<FinanceResponseData>) => void;
}) {
  const { columns, products, responseData, onChange } = props;
  const updateProducts = (
    product: FinalProduct,
    newData: Partial<FinalProduct>,
  ) => {
    const finalProductsList = [...(responseData?.finalizedProductList ?? [])];
    const index = finalProductsList.findIndex((p) => p === product);
    if (index >= 0) {
      finalProductsList[index] = { ...finalProductsList[index], ...newData };
    }
    return finalProductsList;
  };

  const getFieldValue = (column: ProductColumn, val: string) => {
    if (['months', 'miles'].includes(column.fieldName)) {
      return parseNumberIfPresent(val);
    }
    return val;
  };

  const getDescriptionField = (
    product: FinalProduct,
    column: ProductColumn,
  ) => {
    const required =
      REQUIRED_PRODUCT_FIELDS.includes(column.fieldName) && !!product?.value;
    return (
      <Input
        required={required}
        value={product[column.fieldName]}
        placeholder="N/A"
        onChange={(val: string) =>
          onChange({
            finalizedProductList: updateProducts(product, {
              [column.fieldName]: getFieldValue(column, val),
            }),
          })
        }
      />
    );
  };

  return (
    <FormTable
      columns={columns}
      rows={products.map((product) => ({
        descriptions: columns.map((column, i) =>
          getDescriptionField(product, column),
        ),
        value: (
          <PriceInput
            value={product.value}
            placeholder="N/A"
            onChange={(val) =>
              onChange({
                finalizedProductList: updateProducts(product, {
                  value: parseCurrencyTruncated(val),
                }),
              })
            }
          />
        ),
      }))}
    />
  );
}

export default ProductTable;
